import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Text, Message } from 'rsuite';
import {
  selectConfigExpressRegistrationTypeVerbiage,
  selectConfigExpressRenewLateFee,
} from '../../store/slices/config/configSelectors';
import { selectLateRenewalData } from '../../store/slices/renew/renewSelectors';
import { convertNumberToCurrency } from '../../common/utils';

const LateRenewalNotice = () => {
  const selectedPermitTypeVerbiage = useSelector(
    selectConfigExpressRegistrationTypeVerbiage
  );
  const lateRenewalFee = useSelector(selectConfigExpressRenewLateFee);
  const lateRenewalData = useSelector(selectLateRenewalData);

  const lateFeeHeadingText = useMemo(() => {
    return `Your ${selectedPermitTypeVerbiage.toLowerCase()} expired on ${lateRenewalData?.expirationDate} and this renewal is now subject to a ${convertNumberToCurrency(lateRenewalFee)} late fee.`;
  }, [selectedPermitTypeVerbiage, lateRenewalFee, lateRenewalData]);

  const lateFeeDescriptionText = useMemo(() => {
    return `If your ${selectedPermitTypeVerbiage.toLowerCase()} is not renewed on or before ${lateRenewalData?.renewBy}, you will be unable to renew this ${selectedPermitTypeVerbiage.toLowerCase()} and must submit for a new ${selectedPermitTypeVerbiage.toLowerCase()}.`;
  }, [selectedPermitTypeVerbiage, lateRenewalData]);

  return (
    lateRenewalFee &&
    lateRenewalData?.hasExpired && (
      <Message className="mt-24">
        <h4>{lateFeeHeadingText}</h4>
        <Text className="mb-8">{lateFeeDescriptionText}</Text>
      </Message>
    )
  );
};

export default LateRenewalNotice;
